/**
 * Route names.
 * @type {import("./types").RouteNames}
 */
const names = {
    /** Route representing account selection. */
    ACCOUNTS_INDEX: "accounts.index",
    /** Route representing single account homepage. */
    ACCOUNTS_SHOW: "accounts.show",
    /** Route representing homepage. */
    HOMEPAGE: "homepage"
}

export default names;